import React, { useState } from 'react';
import Modal from '../Modal';
import { API } from '@/lib/api';
import type { SubscribeRequest } from 'models/baseResponse';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const SubscriberModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
    const [request, setRequest] = useState<SubscribeRequest>({
        Email: '',
        FirstName: '',
        LastName: ''
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<string | null>(null);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);


    const onCloseHandler = () => {
        setRequest({
            Email: '',
            FirstName: '',
            LastName: ''
        });
        setIsLoading(false);
        setIsError(null);
        setIsSuccess(false);
        onClose();
    }

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRequest((prevRequest) => ({
            ...prevRequest,
            Email: e.target.value,
        }));
    };

    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRequest((prevRequest) => ({
            ...prevRequest,
            FirstName: e.target.value,
        }));
    };

    const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRequest((prevRequest) => ({
            ...prevRequest,
            LastName: e.target.value,
        }));
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const handleSubmit = async () => {

        setIsLoading(true);
        setIsError(null);
        setIsSuccess(false);

        try {
            if (!request.FirstName.trim()) {
                throw new Error('First Name is required.');
            }
            if (!request.LastName.trim()) {
                throw new Error('Last Name is required.');
            }
            if (!request.Email) {
                throw new Error('Email is required');
            }

            if (!emailRegex.test(request.Email)) {
                throw new Error('Please enter a valid email address.');
            }

            await API.subscribe(request);

            setIsSuccess(true);

            setRequest({
                Email: '',
                FirstName: '',
                LastName: ''
            });
        } catch (error:any) {
            setIsError(error.message || 'An error occurred while submitting the form.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (

        <Modal isOpen={isOpen} onClose={onClose} className='light-mint'>
            {/* Modal Form */}
            <div className="w-layout-grid modal-grid-system">
                <div className="limited-heading-set">
                    <div className="heading-set-3">
                        <h2 className="h3-heading">Newsletter Subscription</h2>
                    </div>
                </div>
                <div
                    id="w-node-a3568ff9-cc06-f5c1-3306-e3f4ff723fb4-b45ce221"
                    className="a-filter-filter-form-block-top w-form"
                >
                    <div
                        id="wf-form-Email"
                        data-name="Email"
                        className="a-filter-form-top"
                        data-wf-page-id="66d8269ed48e78e5b45ce221"
                        data-wf-element-id="a3568ff9-cc06-f5c1-3306-e3f4ff723fb5"
                        aria-label="Email"
                    >
                        <div className="a-filter-search">
                            <input
                                className="a-filter-search-text-field jetboost-list-search-input-xr5q w-input"
                                maxLength={256}
                                name="firstName"
                                placeholder="First Name*"
                                type="text"
                                value={request.FirstName}
                                onChange={handleFirstNameChange}
                                disabled={isLoading}
                            />

                        </div>
                        <div className="a-filter-search 2">
                            <input
                                className="a-filter-search-text-field jetboost-list-search-input-xr5q w-input"
                                maxLength={256}
                                name="name"
                                placeholder="Last Name*"
                                type="text"
                                value={request.LastName}
                                onChange={handleLastNameChange}
                                required
                                disabled={isLoading}
                            />

                        </div>
                        <div className="a-filter-search">
                            <input
                                className="a-filter-search-text-field jetboost-list-search-input-xr5q w-input"
                                maxLength={256}
                                placeholder="E-Mail Address*"
                                type="email"
                                value={request.Email}
                                onChange={handleEmailChange}
                                required
                                disabled={isLoading}
                            />

                        </div>
                        <input
                            type="submit"
                            data-wait="Please wait..."
                            className="button-left-icon w-button"
                            value={isLoading ? 'Loading...' : 'Subscribe Now'}
                            control-id="ControlID-2"
                            disabled={isLoading}
                            onClick={handleSubmit}
                        />
                    </div>

                    {isSuccess && (
                        <div className="success-message-3 w-form-done" style={{ display: 'block' }} tabIndex={-1} role="region" aria-label="Email success">
                            <div>Thank You! You'll Receive FDI Strategy and Plans in Your Inbox...</div>
                        </div>
                    )}

                    {isError && (
                        <div className="w-form-fail" style={{ display: 'block' }} tabIndex={-1} role="region" aria-label="Email failure">
                            <div>{isError}</div>
                        </div>
                    )}
                </div>
            </div>

            {/* Close Button */}
            <div className="modal-close-button" onClick={onCloseHandler}>
                <div className="x-button"></div>
            </div>
        </Modal>
    );
};

export default SubscriberModal;
